<template>
    <b-row>
        <b-col cols="12">
            <div class="text-center text-primary my-2" v-if="!component && loadingPlaceholder">
                <b-skeleton :width="loadingSettings.width" :height="loadingSettings.height" class="align-middle" animation="throb"/>
            </div>

            <div v-else-if="component">
                <LegacyComponentApp 
                    :id="getComponentID()" 
                    :nodes="component.settings.templates"  
                    :entrypoint="templateEntrypoint" 
                    :component="component"
                    
                    noRouter

                    v-on="$listeners"

                    v-bind="$attrs"

                    v-if="component.settings.templates_dist === null"
                >
                    <slot v-for="(_, name) in $slots" :name="name" :slot="name"></slot>
                    <template v-for="(_, name) in $scopedSlots" :slot="name" slot-scope="slotData"><slot :name="name" v-bind="slotData" /></template>
                </LegacyComponentApp>

                <PowerAppV4 
                    :app="component.general" 
                    :dist="component.settings.templates_dist.dist"  
                    :entrypoint="templateEntrypoint" 
                    :component="component"
                    
                    noRouter

                    v-on="$listeners"

                    v-bind="$attrs"

                    v-if="component.settings.templates_dist !== null && component.settings.templates_dist.sdk_version === 4"
                >
                    <slot v-for="(_, name) in $slots" :name="name" :slot="name"></slot>
                    <template v-for="(_, name) in $scopedSlots" :slot="name" slot-scope="slotData"><slot :name="name" v-bind="slotData" /></template>
                </PowerAppV4>

                <PowerAppV5
                    :app="component.general"
                    :dist="component.settings.templates_dist.dist"  
                    :entrypoint="templateEntrypoint"
                    :component="component" 
                    
                    noRouter

                    v-on="$listeners"

                    v-bind="$attrs"

                    v-if="component.settings.templates_dist !== null && component.settings.templates_dist.sdk_version === 5"
                >
                    <slot v-for="(_, name) in $slots" :name="name" :slot="name"></slot>
                    <template v-for="(_, name) in $scopedSlots" :slot="name" slot-scope="slotData"><slot :name="name" v-bind="slotData" /></template>
                </PowerAppV5>

                <ComponentDist 
                    v-if="component.settings.templates_dist !== null && component.settings.templates_dist.sdk_version === 6" 

                    :entrypoint="templateEntrypoint"
                    :component="component" 
                    :dist="component.settings.templates_dist"
                ></ComponentDist>
            </div>
        </b-col>
    </b-row>
</template>

<script>
export default {
    name: 'ComponentView',
    components: {
        LegacyComponentApp: () => import('./ComponentApp'),
        PowerAppV4: () => import('@/views/apps/PowerAppV4'),
        PowerAppV5: () => import('@/views/apps/PowerAppV5'),
        ComponentDist: () => import('./ComponentDist'),
    },
    props: {
        id: {
            type: String,
            default: null
        },

        entrypoint: {
            type: String,
        },

        loadingSettings: {
            type: Object,
            default: () => {
                return {
                    width: "100%",
                    height: "250px"
                }
            }
        },

        loadingPlaceholder: {
            type: Boolean,
            default: false
        }
    },
    data: () => {
        return {
            component: null
        }
    },
    computed: {
        isCustomTemplate() {
            return this.templateEntrypoint != ''
        },

        templateEntrypoint() {
            return this.entrypoint
        }
    },
    methods: {
        getComponentID() {
            return this.id
        }
    },

    updated() {
        console.log("[Render] ComponentView rendered")
    },

    created() {
        this.$store.dispatch("fetchComponentsSettings", this.getComponentID()).then(data => {
            this.component = data
        }).catch((err) => {
            console.error(err)
            this.$bvToast.toast(this.$t('unexpectedError'), {
                variant: 'danger'
            })
        })
    },
}
</script>
